import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.536 8.066c.78-.781.939-1.89.353-2.475-.586-.586-1.694-.428-2.475.353-.78.781-.94 1.89-.353 2.475.585.586 1.693.428 2.475-.353ZM9.06 5.59c-.585.587-.427 1.695.354 2.476.781.78 1.89.939 2.475.353.586-.586.428-1.694-.353-2.475-.782-.78-1.89-.939-2.475-.353Zm-1.438 6.504a.5.5 0 0 0 .756 0l1.504-1.736a.5.5 0 0 0-.378-.828H6.496a.5.5 0 0 0-.378.828l1.504 1.736Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.807 5.526C15.528 5.014 16 4.211 16 3.296 16 1.735 14.657.47 13 .47a3.06 3.06 0 0 0-2.029.76 6.184 6.184 0 0 0-5.942 0A3.062 3.062 0 0 0 3 .47c-1.657 0-3 1.264-3 2.824 0 .916.472 1.72 1.193 2.231C.015 7.875-.64 10.84.935 12.985 2.173 14.675 4.55 15.53 8 15.53s5.827-.856 7.065-2.543c1.575-2.146.92-5.113-.258-7.46Zm-1.387 6.39c-.843 1.15-2.666 1.732-5.42 1.732s-4.577-.583-5.42-1.73c-1.05-1.434-.417-3.61.055-4.78C3.085 6.013 4.808 2.353 8 2.353s4.914 3.66 5.365 4.783c.472 1.17 1.106 3.346.055 4.78Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconInfrastructureZoo16 = createIcon(IconComponent);